import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import img_serpiente_identificacion from "../../../assets/images/img_serpiente_identificacion.png";
import ico_caso_exito from "../../../assets/icons/ico_caso_exito.svg";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const VisualIdentificationScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const arenoso = "_xd45qDajX4";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);
  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={arenoso}></VideoBanner>
          </div>

          <div className="w-full mx-auto text-white relative h-fit  ">
            <div className="absolute right-0 mt-[12rem] mb-10">
              <img
              
                src={img_serpiente_identificacion}
                className="lg:w-[51rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>

            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[57rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Anfibios y reptiles"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Identificación visual
                      <br /> en línea recta
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[15.5rem] mg:pb-[5rem] sm:pb-[5rem] pb-[5rem]">
                      La <b>identificación visual en línea recta</b> consiste en que dos o más personas caminen lentamente a lo largo de una línea y, cuidadosamente, busquen anfibios y reptiles descansando sobre el suelo, hojarasca, troncos podridos, arbustos y ramas.

                    </p>

                  }
                ></ToolsInfoSection>

              </div>
              <div className="relative col-span-3 2xl:mt-[12.5rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                    <img
                    
                      src=""
                      className="w-[50rem] mt-[3.5rem] right-0 absolute z-0 top-0"
                    ></img>
                    <div className="h-44 w-full bg-[#ffb223] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                      <div className="grid grid-cols-2 grid-rows-1 relative text-white">
                        <div className="inline-flex items-center py-5 ml-10">
                          <img loading="lazy" src={ico_caso_exito}></img>
                          <label className="ml-5 text-2xl font-bold">
                            Caso <br /> de éxito
                          </label>
                        </div>
                        <p className="py-16 text-lg">
                          Estudios de herpetofauna en Puro Verde <br /> Paraíso
                          Forestal.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                    <ToolsTab
                    firstTitle="Sistemas productivos y naturales"
                    secondTitle="Resultados y beneficios"
                      firstTab={
                        <div>
                          <p className="text-xl mb-5">
                          Se recomienda monitorear la presencia de anfibios y reptiles en los fragmentos de bosque secundario y en los bosques de ribera asociados a ríos, en paisajes productivos.
                          </p>
                          <p className="text-xl mb-5">
                            En cuanto a operaciones turísticas, se recomienda
                            identificar la presencia de anfibios o reptiles en
                            los terrenos privados, ya sean bosques maduros o en
                            regeneración.
                          </p>
                          <p className="text-xl mb-5">
                          Se debe priorizar los sitios cercanos a cuerpos de agua: márgenes de arroyos, ríos, pozas o sitios con agua estancada, ya sean permanentes o estacionales.
                          </p>
                          <p className="text-xl mb-5">
                            Se recomienda realizar el monitoreo cada 6 meses.
                          </p>
                        </div>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                            Los resultados del monitoreo pueden evidenciar el
                            aumento de riqueza de especies.
                          </p>
                          <p className="text-xl mb-5">
                            Brinda información para proteger sitios importantes
                            para la biodiversidad.
                          </p>
                          <p className="text-xl mb-5">
                          A través del análisis de las especies pueden surgir nuevos atractivos turísticos y especies llamativas.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute ">
            <VideoBanner idVideo={arenoso}></VideoBanner>
            <div className=" absolute right-0 bottom-0 ">
              <img
              
                src={img_serpiente_identificacion}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem]"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1 2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10  pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[30rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <div className="lg:h-44 md:h-32 sm:h-24 h-24 w-full bg-[#ffb223] relative">
                <div className="grid grid-cols-2 grid-rows-1 relative text-white lg:py-16 md:py-5 sm:py-2 py-2 lg:px-10 md:px-5 sm:px-5 px-5">
                  <div className="inline-flex items-center  ">
                    <img
                    
                      src={ico_caso_exito}
                      className="lg:w-20 md:w-14 sm:w-14 w-14"
                    ></img>
                    <label className=" lg:text-2xl md:text-xl sm:text-lg text-lg font-bold ml-3">
                      Caso <br /> de éxito
                    </label>
                  </div>
                  <p className=" lg:text-lg md:text-base sm:text-sm text-sm">
                    Estudios de herpetofauna en Puro Verde <br /> Paraíso
                    Forestal.
                  </p>
                </div>
              </div>
              <ToolsInfoSection
                firstIcon={ico_handy_orange}
                secondIcon={ico_huellas_green}
                tag="Anfibios y reptiles"
                title={
                  <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-5 ">
                    Identificación visual
                   en línea recta
                  </h1>
                }
                text={
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[15.5rem] mg:pb-[10rem] sm:pb-[10rem] pb-[10rem]">
                    La <b>identificación visual en línea recta</b> consiste en que dos o más personas caminen lentamente a lo largo de una línea y, cuidadosamente, busquen anfibios y reptiles descansando sobre el suelo, hojarasca, troncos podridos, arbustos y ramas.
                  </p>
                }
              ></ToolsInfoSection>

            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
              <ToolsTab
              firstTitle="Sistemas productivos y naturales"
              secondTitle="Resultados y beneficios"
                firstTab={
                  <div>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Se recomienda monitorear la presencia de anfibios y
                      reptiles en los fragmentos de bosque secundario y bosques
                      de ribera asociados a ríos, en paisajes productivos.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      En cuanto a operaciones turísticas, se recomienda
                      identificar la presencia de anfibios o reptiles en los
                      terrenos privados, ya sean bosques maduros o en
                      regeneración.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                    Se debe priorizar los sitios cercanos a cuerpos de agua: márgenes de arroyos, ríos, pozas o sitios con agua estancada, ya sean permanentes o estacionales.
                    </p>
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      Se recomienda realizar el monitoreo cada 6 meses.
                    </p>
                  </div>
                }
                secondTab={
                  <div>
                    <p className="lg:text-xl md:text-lg sm:text-base text-base mb-5">
                      Los resultados del monitoreo pueden evidenciar el aumento
                      de riqueza de especies.
                    </p>
                    <p className="lg:text-xl md:text-lg sm:text-base text-base mb-5">
                      Brinda información para proteger sitios importantes para
                      la biodiversidad.
                    </p>
                    <p className="lg:text-xl md:text-lg sm:text-base text-base mb-5">
                    A través del análisis de las especies pueden surgir nuevos atractivos turísticos y especies llamativas.
                    </p>
                  </div>
                }
              ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisualIdentificationScreen;
